import React, { useEffect } from "react";
import { Modal, Button } from "antd";
import TwoFAContent from "./TwoFAContent";
import { useIntl } from "react-intl";
import { PhoneMultiFactorGenerator } from "firebase/auth";
const TwoFAModal = (props) => {
  const {
    visible,
    handleCancel,
    phoneNumber,
    onCodeChange,
    onSubmitCode,
    onResend,
    twoFAError,
    twoFACode,
    resendLoading,
    loading,
    activeFactorId,
    hasMobileFactor,
    switchToMobileAuthantication,
  } = props;
  const intl = useIntl();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && twoFACode && twoFACode.length >= 6) {
        onSubmitCode();
      }
    };
    // Attach the event listener
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      // Cleanup: remove the event listener
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [twoFACode, onSubmitCode]);

  return (
    <Modal
      maskClosable={false}
      title={intl.formatMessage({
        id: "app.forms.user.2faTitle",
      })}
      centered
      onCancel={handleCancel}
      open={visible}
      footer={[
        <div
          key="factors"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {activeFactorId === PhoneMultiFactorGenerator.FACTOR_ID ? (
            <Button
              loading={resendLoading}
              key="resend"
              type="text"
              onClick={onResend}
            >
              {intl.formatMessage({
                id: "app.actions.resend",
              })}
            </Button>
          ) : (
            <div />
          )}

          <div>
            <Button key="cancel" onClick={handleCancel}>
              {intl.formatMessage({
                id: "app.actions.cancel",
              })}
            </Button>
            <Button
              key="approve"
              type="primary"
              onClick={onSubmitCode}
              disabled={!twoFACode || twoFACode.length < 6}
              loading={loading}
            >
              {intl.formatMessage({
                id: "app.actions.approve",
              })}
            </Button>
          </div>
        </div>,
      ]}
    >
      <TwoFAContent
        phoneNumber={phoneNumber}
        onCodeChange={onCodeChange}
        twoFAError={twoFAError}
        twoFACode={twoFACode}
        activeFactorId={activeFactorId}
        hasMobileFactor={hasMobileFactor}
        switchToMobileAuthantication={switchToMobileAuthantication}
      />
    </Modal>
  );
};

export default TwoFAModal;
